module.exports = __webpack_public_path__ + "static/img/8.4dff360.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting811/images/8.png
// module id = ucaV
// module chunks = 4